/**
 * @module generateAlbumSubtitle
 */

/**
 * Convenience function to generate a subtitle for the specified album data with the copyright date year (when available) and number of songs.
 *
 * @param {object} mediaItem - The media item from which to derive the album subtitle.
 *
 * @returns {string} The subtitle value for the specified album with the copyright date year (when available) and number of songs.
 */
function generateAlbumSubtitleByMediaItem(mediaItem) {
  let subtitle = '';
  if (
    mediaItem &&
    mediaItem.media_collection_type &&
    mediaItem.media_collection_type.albumCopyrightDate
  ) {
    subtitle += `${new Date(
      mediaItem.media_collection_type.albumCopyrightDate,
    ).getFullYear()}`;
  }
  if (mediaItem && mediaItem.parts) {
    if (subtitle) {
      subtitle = `${subtitle} - `;
    }
    subtitle += `${mediaItem.parts} Song`;
    if (parseInt(mediaItem.parts, 10) > 1) {
      subtitle += 's';
    }
  }
  return subtitle;
}

/**
 * Convenience function to create the album subtitle.
 *
 * @param {string} albumCopyrightDate - The album copyright date.
 * @param {string} parts - The number of parts.
 *
 * @returns {string} The string containing the copyright year and number of songs (Example: '2023 - 10 Songs').
 */
function generateAlbumSubtitle(albumCopyrightDate, parts) {
  let subtitle = '';
  if (albumCopyrightDate) {
    subtitle += `${new Date(albumCopyrightDate).getFullYear()}`;
  }
  if (parts) {
    if (subtitle) {
      subtitle = `${subtitle} - `;
    }
    subtitle += `${parts} Song`;
    if (parseInt(parts, 10) > 1) {
      subtitle += 's';
    }
  }
  return subtitle;
}

module.exports = {
  generateAlbumSubtitle,
  generateAlbumSubtitleByMediaItem,
};
